module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAZCAIAAABCYLJOAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3wQUCyITKh6KTQAAAEBJREFUSEtj/P//PwMNABMhBWSCUXMhYNRcCCDB3KlTpxJSggCMA58vRt1LBhh1LwSMuhcCSHAvSWDUXAiglbkAi0MfkZVUq1gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer-logo-spacer.png
// module id = /zL1
// module chunks = 1 2 3